import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import * as React from 'react';
import S from './TabbedSignpostCard.styles';
const TabbedSignpostCard = (props) => {
    const imageSrc = props.image ? getSrcs(props.image, 628, 312, 3, 271 / 279) : null;
    return (React.createElement(S.Container, { href: props.cta?.url, target: props.cta?.target, "data-has-curve": props.parentTheme === 'beige' },
        React.createElement(S.ImageContainer, { "data-bg-color": props.typeTheme ?? 'intermediaries' },
            imageSrc && props.image && (React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, alt: props.image.altText ?? props.title, loading: "lazy", sizes: `${until(Device.Tablet)} 50vw, ${until(Device.TabletLarge)} 33vw, ${until(Device.Desktop)} 25vw, ${until(Device.ActualDesktop)} 16.67vw, 271px` })),
            !props.image && getSystemIcon(props.icon ?? SystemIcon.SpeechBubble)),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.ContentArea, null,
                React.createElement(S.Heading, null, props.title),
                props.description && React.createElement(S.Description, null, props.description)))));
};
export default TabbedSignpostCard;
